export enum FileMetadataTypesEnum {
  APK = 'APK',
  ICON = 'ICON',
  SCREENSHOT = 'SCREENSHOT',
  FW = 'FW',
  DOCUMENT = 'DOCUMENT',
}
